import {
  Box,
  Flex,
  ListItem,
  ModalBody,
  ModalFooter,
  ModalHeader,
  OrderedList,
} from '@chakra-ui/react'

import { Button } from '@/components/ui'

import { GridModalHeader } from '../../components/GridModalHeader'

interface InstructionsStepIProps {
  onBegin: () => void
  onClose: () => void
}

export const InstructionsStep = ({
  onBegin,
  onClose,
}: InstructionsStepIProps) => (
  <>
    <ModalHeader p={0} w='100%'>
      <GridModalHeader subtitle='' title='Grid Testing Zone' />
    </ModalHeader>
    <ModalBody p={0}>
      <Box>
        <OrderedList color='gray.700' fontSize='sm' spacing={2}>
          <ListItem>Review and adjust the camera grids.</ListItem>
          <ListItem>
            Select a past incident and enter expected IN/OUT counts.
          </ListItem>
          <ListItem>
            Await results while the video is processed by the Ingress Detector.
          </ListItem>
          <ListItem>View the detection accuracy results.</ListItem>
          <ListItem>
            Save your new grid configuration or return to Step 2 in order to
            continue testing.
          </ListItem>
        </OrderedList>
      </Box>
    </ModalBody>
    <ModalFooter mt={6} p={0}>
      <Flex direction='row' gap={3} justifyContent='flex-end'>
        <Button mr={0} onClick={onClose} variant='secondary'>
          Cancel
        </Button>
        <Button onClick={onBegin}>Enter</Button>
      </Flex>
    </ModalFooter>
  </>
)
